<h1 class="titles">
  <span>2/4</span> Ð¢ÐµÐºÑÑ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ñ
</h1>

<div class="message-text-block">

  <form *ngIf="formGroup" [formGroup]="formGroup">

    <div class="message-text">

      <span>ÐÐ°Ð¿Ð¸ÑÐ¸ÑÐµ, ÑÑÐ¾ Ð²Ñ ÑÐ¾ÑÐ¸ÑÐµ Ð¾Ð¿ÑÐ±Ð»Ð¸ÐºÐ¾Ð²Ð°ÑÑ Ð² ÑÐ°ÑÐµ Ð´Ð¾Ð¼Ð°</span>
      <textarea formControlName="messageText"
                type="text"
                #messageText>
      </textarea>
    </div>

  </form>

</div>

<lib-button *ngIf="formGroup"
            [disabled]="formGroup.invalid"
            (click)="nextStep()">ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ
</lib-button>
